import {FlowTypeProps} from "../../../types/FlowTypeProps";
import React, {ReactNode} from "react";
import "./button-group.css";

interface ButtonGroupItem {
    id: number | string;
    title: string;
    description?: string;
    icon?: ReactNode | ReactNode[];
    isSelected?: boolean;
}

interface ButtonGroupProps {
    items: ButtonGroupItem[];
    onClick: (newId: number | string) => void;
    descriptionAlwaysOn?: boolean;
    disabled?: boolean;
}

const ButtonGroup = ({ disabled, items, onClick, descriptionAlwaysOn = false }: ButtonGroupProps) => {
    return (
        <div className={`buttons-group-container ${disabled ? 'disabled' : ''}`}>
            {items.map((item: ButtonGroupItem) =>
                <div className={`button-group-item ${item.isSelected ? ' selected ' : ''}`} key={`flow-type-${item.id}`} onClick={() => disabled ? null : onClick(item.id)}>
                    {item.icon ? <div className="icon">{item.icon}</div> : null}
                    <div className="title">{item.title}</div>
                    {item.description ? <div className={`description ${descriptionAlwaysOn ? 'always-on' : ''}`}>{item.description}</div> : null}
                </div>
            )}
        </div>
    )
}

export default ButtonGroup;